module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.blockClass
  }, [_c('div', {
    staticClass: "releasecontainer"
  }, [_c('div', {
    staticClass: "releaseheader"
  }, [_c('div', [_c('div', {
    staticClass: "sdkname"
  }, [_vm._v(_vm._s(_vm.release.sdk))]), _vm._v(" "), _c('div', {
    staticClass: "version"
  }, [_vm._v(_vm._s(_vm.release.version))])]), _vm._v(" "), _c('div', {
    staticClass: "releasedateblock"
  }, [_c('span', [_vm._v("Released on")]), _vm._v(" "), _c('span', {
    staticClass: "releasedate"
  }, [_vm._v(_vm._s(_vm.formattedDate))])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.apiUrl
    }
  }, [_c('div', {
    staticClass: "button"
  }, [_vm._v("API")])])])]), _vm._v(" "), _c('div', {
    staticClass: "example",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedExample)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-002a4083!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ReleaseBlock.vue
// module id = 137
// module chunks = 0